import { api } from '@api'

const getPendings = async (): Promise<number> => {
  const response = await api.get<{ carrierPendings: number | undefined }>(
    '/tickets/carrier-pendings/count',
  )
  return response.data.carrierPendings ?? 0
}

export { getPendings }
